import { defineStore } from 'pinia'
import type { RouteLocationRaw } from 'vue-router'

const APP_TITLE = import.meta.env.VITE_APP_TITLE ?? 'Panel Admin'

type BreadcrumbItem = {
  label: string,
  route?: RouteLocationRaw,
}
type State = {
  title: string,
  breadcrumb: BreadcrumbItem[],
  canNavigateAway: boolean,
}
const HomeRoute: BreadcrumbItem = {
  label: 'Home',
  route: { name: 'home' },
}

export const useAppStore = defineStore('App', {
  state: (): State => ({
    title: '',
    breadcrumb: [HomeRoute],
    canNavigateAway: true,
  }),
  actions: {
    setPageTitle (title: string) {
      this.title = title
      document.title = `${title} | ${APP_TITLE}`
    },
    setBreadcrumb (routes: BreadcrumbItem[]) {
      this.breadcrumb = [
        HomeRoute,
        ...routes,
      ]
    },
    allowNavigateAway () {
      this.canNavigateAway = true
    },
    forbidNavigateAway () {
      this.canNavigateAway = false
    },
  },
})

/**
 * Notes: canNavigateAway is reverted to true on form-invoice onUnmounted
 */
